import { PinnedItem, PinnedItemType } from '@/forwarding/entities/PinnedItem/PinnedItem';
import { PinnedProduct } from '@/forwarding/entities/PinnedItem/PinnedProduct';
import {
  BASE_PRODUCT_TYPE_ORDER,
  BaseProductType,
  formatBaseProductTypeLabel,
} from '@/product/constants/productTypes';

// Builds a human-readable summary like '3 diamonds, 2 rough diamonds, 2 gems, 1 project and 2 links'.
export function getPinnedItemsTitle(items: PinnedItem[]): string {
  const productCounts = new Map<BaseProductType, number>();
  let projectCount = 0;
  let linkCount = 0;

  items.forEach((item) => {
    if (item instanceof PinnedProduct) {
      productCounts.set(item.productType, (productCounts.get(item.productType) ?? 0) + 1);
    } else if (item.type === PinnedItemType.CarbonProject) {
      projectCount += 1;
    } else if (item.type === PinnedItemType.Url) {
      linkCount += 1;
    }
  });

  const parts: string[] = [];

  BASE_PRODUCT_TYPE_ORDER.forEach((productType) => {
    const count = productCounts.get(productType);

    if (count) {
      parts.push(`${count} ${formatBaseProductTypeLabel(count, productType)}`);
    }
  });

  if (projectCount) {
    parts.push(pluralize(projectCount, 'project', 'projects'));
  }

  if (linkCount) {
    parts.push(pluralize(linkCount, 'link', 'links'));
  }

  return joinWithAnd(parts);
}

function pluralize(count: number, singular: string, plural: string): string {
  return `${count} ${count === 1 ? singular : plural}`;
}

function joinWithAnd(parts: string[]): string {
  if (parts.length <= 1) {
    return parts[0] ?? '';
  }

  return `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
}
